import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { url } from '../../../constants/routes';
import { connect } from '../../../reducers/index';
import './styles.css';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import SingleSelectQuestions from '../../../components/Questions/SingleSelectQuestions';
import UnClickableScreenReader from '../../../components/ScreenReader/UnClickableScreenReader';
// import AssistGraphic02 from '../img/assist-prof-holding-map-graphic.svg';

const AssistPage = props => {
  const questions = {
    //title: 'Question 5b: Strategies',
    type: 'single',
    text: (
      <Fragment>
        <UnClickableScreenReader
          text={`Personal Reflection: How do you feel when using this component when trying to assist someone?`}
        />
        <strong>
          Personal Reflection: How do you feel when using this component when trying to assist someone?
        </strong>
      </Fragment>
    ),
    result: [],
    feedback: {
      correct: '',
      incorrect: '',
      all: ''
    }
  };
  const options = [
    {
      prefix: 'A',
      result: '',
      optionText:
        'I have to be really focused and intentional when doing this. '
    },
    {
      prefix: 'B',
      result: '',
      optionText:
        'I am often able to do this but it’s a good reminder.'
    },
    {
      prefix: 'C',
      result: '',
      optionText:
        'I always do this.'
    }
  ];
  return (
    <EducationModuleLayout
      progressStage={4}
      childTitle="Assist"
      progressType="assist"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader text="2. Validate their feelings" />
              <h2 className="txt-green no-bold no-margin">
                2. Validate their feelings
              </h2>
            </Col>
          </Row>
        </div>
      </section>
      <section className="no-bottom-padding">
        <div className="container">
          <Row>
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader text="This component involves recognizing someone’s feelings, acknowledging them as important and empathizing with them. By relating to their emotions, it can help you validate what they are feeling. You could say, “That sounds hard.” or “It sounds like you are having a difficult time.” When someone decides to disclose personal information about themselves they may feel very vulnerable. It’s very important to thank them for trusting you and being open to discussing these feelings. You could say, “Thank you for trusting me with this.” or “Thank you for sharing this with me.” " />
              <p>
                This component involves recognizing someone’s feelings, acknowledging them as important and empathizing with them.
                By relating to their emotions, it can help you validate what they are feeling. You could say, <span className="italic">“That sounds hard.” </span>
                or <span className="italic">“It sounds like you are having a difficult time.”</span>
              </p>
              <p>
                When someone decides to disclose personal information about themselves they may feel very vulnerable. It’s very
                important to thank them for trusting you and being open to discussing these feelings. You could say,&nbsp;
                <span className="italic">“Thank you for trusting me with this.”</span> or&nbsp;
                <span className="italic">“Thank you for sharing this with me.”</span>
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <SingleSelectQuestions
        questions={questions}
        options={options}
        questionType="assist"
        categoary="survey"
        showLetter={false}
        nextRoute={url.ASSIST_E}
        previousRoute={() => props.history.goBack()}
      />
    </EducationModuleLayout>
  );
};

AssistPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const AssistD = connect.role(AssistPage);

export default AssistD;



// WEBPACK FOOTER //
// ./src/containers/Assist/AssistD/index.jsx